//@flow

// Vendors
import React from 'react';
import PropTypes from 'prop-types';

// Components
import SessionWarningModal from '../SessionWarningModal/SessionWarningModal';
import VRRSessionWarningModal from '../VRRSessionWarningModal/VRRSessionWarningModal';
import SurrenderDLForIDSessionWarningModal from '../SurrenderDLForIDSessionWarningModal/SurrenderDLForIDSessionWarningModal';

const modalMap = {
  SessionWarningModal,
  VRRSessionWarningModal,
  SurrenderDLForIDSessionWarningModal,
};

const WarningModalWrapper = ({ name = 'SessionWarningModal', ...props }) => {
  const Modal = modalMap[name];
  return <Modal {...props} />;
};

WarningModalWrapper.propTypes = {
  name: PropTypes.string.isRequired,
};

export default WarningModalWrapper;
